<template>
    <div>
        <div class="wrapper" :style="getWrapperStyle">
            <div class="clock" :style="getClockStyle"> {{getTime}}</div>
            <div class="date">{{getDate}}</div>
        </div>
    </div>

</template>


<script>
    export default {
        settings: {

            clockColor: {
                type: "color-picker",
                pos: {
                    x: 10,
                    y: 10
                }
            },
            wrapper: [
                {
                    color: {
                        type: "color-picker",
                        pos: {
                            x: 10,
                            y: 10
                        }
                    }
                },
                {
                    background: {
                        type: "color-picker",
                        pos: {
                            x: 30,
                            y: 30
                        }
                    }
                }, {
                    height: {
                        type: "pixel",
                        pos: {
                            x: 20,
                            y: 20
                        }
                    }
                }
            ]
        },
        name: 'clock-block',
        props: {
            config: {},
            componentData: {},


        },
        data() {
            return {
                currentTime: new Date()
            }
        },
        computed: {
            getTime() {
                return moment(this.currentTime).format('HH:mm')
            },
            getDate() {
                return moment(this.currentTime).format('DD/MM/YY')
            },
            getClockStyle() {
                var CSS_STRING = "color:" + this.config.clockColor + ";"

                return CSS_STRING
            },
            getWrapperStyle() {
                var CSS_STRING = "color:" + this.config.wrapper.color + ";"
                CSS_STRING += "background:" + this.config.wrapper.background + ";"
                CSS_STRING += "height:" + this.config.wrapper.height + ";"
                return CSS_STRING

            }
        },
        methods: {},
        created() {
            this.currentTime = moment.now()
            var self = this
            setInterval(function(){
                self.currentTime = moment.now()
            },5000)

        }
    }
</script>
<style lang="scss" scoped>

    .wrapper {
        height: 100%;
        font-size: 40px;
        font-weight: 700;
        .clock {
            position: absolute;
            top: 40%;
            width: 100%;
            -webkit-transform: translateY(-50%);
            transform: translateY(-50%);
            text-align: center;
            font-size: 100px;
            font-weight: 700;
            vertical-align: middle;
        }
        .date {
            position: absolute;
            top: 65%;
            width: 100%;
            -webkit-transform: translateY(-50%);
            transform: translateY(-50%);
            text-align: center;
            font-size: 80px;
            font-weight: 500;
            vertical-align: middle;
        }
    }
</style>